class CoreDatepicker extends HTMLElement {
  /** @type {unknown} */
  #datePicker = null;

  connectedCallback() {
    const LOYALTY_MINIMUM_AGE = -15 * 365; // 15 years old minimum age for loyalty
    const DEFAULT_MAX_DATE_OFFSET_DAYS = 90;
    const datepickerInput = this.querySelector('input');
    const isLoyalty = this.dataset?.isLoyalty === 'true' || false;
    const today = new Date();
    const maxDate = isLoyalty ? new Date().fp_incr(LOYALTY_MINIMUM_AGE) : new Date().setDate(today.getDate() + DEFAULT_MAX_DATE_OFFSET_DAYS);

    if (datepickerInput) {
      this.#datePicker = window?.flatpickr(datepickerInput, {
        maxDate: maxDate,
        disableMobile: true,
        dateFormat: window?.Theme?.translations?.recipient_form_date_format || 'd/m/Y',
      });
    }
  }

  disconnectedCallback() {
    this.#datePicker?.destroy();
    this.#datePicker = null;
  }
}

if (!customElements.get('core-datepicker')) {
  customElements.define('core-datepicker', CoreDatepicker);
}
